import store from '@/store';
import { cifUpdateRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';

const cifDateFormat = function(date) {
    var datetoConvert = new Date(date);
    var dobDate = datetoConvert.getDate();
    var dobMonth = datetoConvert.getMonth();
    var dobYear = datetoConvert.getFullYear();
    let month = '';
    var newdobDate = dobDate < 10 ? '0' + '' + dobDate + '' : '' + dobDate + '';
    let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
    ];
    for (var i = 0; i < 12; i++) {
        if (i === dobMonth) {
            month = monthNames[i];
        }
    }
    return newdobDate + '-' + month + '-' + '' + dobYear + '';
};


const getPayload = () => {
    const { values } = store.state.formData;
    const { appId, cifnumber, docNumber, promoCodeStatus, productType } = store.state;
    const dob = cifDateFormat(getValueByFieldName(values, FIELD_NAMES.birthDate));
    const nationality = getValueByFieldName(values, FIELD_NAMES.nationality);
    const residenceType = getValueByFieldName(values, FIELD_NAMES.residenceType);
    const employmentType = getValueByFieldName(values, FIELD_NAMES.employmentType);
    const emirateID = getValueByFieldName(values, FIELD_NAMES.emiratesID);
    const emiratesIdExpiryDate = cifDateFormat(getValueByFieldName(values, FIELD_NAMES.expiryDate));
    const maritalStatus = getValueByFieldName(values, FIELD_NAMES.maritalStatus);
    const customerVintage = getValueByFieldName(values, FIELD_NAMES.livingTime);
    const gender = getValueByFieldName(values, FIELD_NAMES.gender);
    const fixedIncome = getValueByFieldName(values, FIELD_NAMES.fixedIncome);
    let passportExpiryDate, passportNumber;
    const product = getValueByFieldName(values, FIELD_NAMES.product);
    var salesProduct;
    if (product === 'Top Up') {
        salesProduct = 'TOPUP'
    } else if (product === 'New Car' || product === 'Used Car') {
        salesProduct = 'Auto Loan'
    } else {

        salesProduct = product
    }
    if (getValueByFieldName(values, FIELD_NAMES.passportNumber)) {
        passportNumber = getValueByFieldName(values, FIELD_NAMES.passportNumber);
    }
    if (getValueByFieldName(values, FIELD_NAMES.passportExpiryDate)) {
        passportExpiryDate = cifDateFormat(getValueByFieldName(values, FIELD_NAMES.passportExpiryDate));
    }
    var promoCode = "";
    if (promoCodeStatus && promoCodeStatus === 'SUCCESS') {
        promoCode = getValueByFieldName(values, FIELD_NAMES.promoCodeInput);
    }

    let title = '';
    if (gender === 'M') {
        title = 'MR.';
    } else if (gender === 'F') {
        title = 'MS.'
    }
    if (product === 'Top Up' || product === 'New Car' || product === 'Used Car') {
        return {
            "app-id": appId,
            "cif-number": cifnumber,
            "gender": gender,
            "dob": dob,
            "title": title,
            "marital-status": maritalStatus,
            "customer-vintage": customerVintage,
            "nationality": nationality,
            "variable-income": fixedIncome,
            "ethinicity": null,
            "accomodation-type": residenceType,
            "passport-no": typeof passportNumber !== 'undefined' ? passportNumber : "",
            "passport-expiry": typeof passportExpiryDate !== 'undefined' ? passportExpiryDate : "",
            "visa-no": null,
            "visa-expiry": null,
            "id-type": 'EID',
            "emirates-id-no": emirateID,
            "eid-card-no": docNumber,
            "eid-expiry-date": emiratesIdExpiryDate,
            "employment-type": employmentType,
            "cycle-date": null,
            "product-name": salesProduct,
            "promo-code": promoCode
        };
    }
    return {
        "app-id": appId,
        "cif-number": cifnumber,
        "gender": gender,
        "dob": dob,
        "title": title,
        "marital-status": maritalStatus,
        "customer-vintage": customerVintage,
        "nationality": nationality,
        "variable-income": fixedIncome,
        "ethinicity": null,
        "accomodation-type": residenceType,
        "passport-no": typeof passportNumber !== 'undefined' ? passportNumber : "",
        "passport-expiry": typeof passportExpiryDate !== 'undefined' ? passportExpiryDate : "",
        "visa-no": null,
        "visa-expiry": null,
        "id-type": 'EID',
        "emirates-id-no": emirateID,
        "eid-card-no": docNumber,
        "eid-expiry-date": emiratesIdExpiryDate,
        "employment-type": employmentType,
        "cycle-date": null,
        "product-name": productType === 'Personal_Loan' ? 'Personal Loan' : productType,
        "promo-code": promoCode

    };
};

export default {
    async cifUpdate(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: cifUpdateRepository.cifUpdate,
            payload: getPayload(),
        });
    }
};